import React from 'react'
import PropTypes from 'prop-types'
import Highlighter from 'react-highlight-words'
import CreatableSelect from 'react-select/creatable'
import {
  MenuItem,
  Paper,
  SvgIcon,
  TextField,
  Typography,
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { mdiAccountPlus } from '@mdi/js'

function inputComponent(args) {
  const { inputRef, ...props } = args
  return <div ref={inputRef} {...props} />
}

function Control(args) {
  return (
    <TextField
      fullWidth
      InputProps={{
        inputComponent,
        inputProps: {
          className: args.selectProps.classes.input,
          inputRef: args.innerRef,
          children: args.children,
          ...args.innerProps,
        },
      }}
      {...args.selectProps.textFieldProps}
    />
  )
}

function Option(args) {
  return (
    <MenuItem
      className={args.isFocused ? args.selectProps.classes.optionFocus : ''}
      buttonRef={args.innerRef}
      selected={args.isSelected}
      component="div"
      {...args.innerProps}
    >
      {typeof args.children === 'string'
        && (
          <Highlighter
            searchWords={[args.selectProps.inputValue]}
            textToHighlight={args.children}
          />
        )}
      {typeof args.children !== 'string'
        && args.children}
    </MenuItem>
  )
}

function Placeholder(args) {
  return (
    <Typography
      color="textSecondary"
      className={args.selectProps.classes.placeholder}
      {...args.innerProps}
    >
      {args.children}
    </Typography>
  )
}

function NoOptionsMessage(args) {
  return (
    <Typography
      color="textSecondary"
      className={args.selectProps.classes.noOptionsMessage}
      {...args.innerProps}
    >
      {args.children}
    </Typography>
  )
}

function SingleValue(args) {
  return (
    <Typography className={args.selectProps.classes.singleValue} {...args.innerProps}>
      {args.children}
    </Typography>
  )
}

function ValueContainer(args) {
  return (
    <div className={args.selectProps.classes.valueContainer}>{args.children}</div>
  )
}

function Menu(args) {
  return (
    <Paper square className={args.selectProps.classes.paper} {...args.innerProps}>
      {args.children}
    </Paper>
  )
}

class DoorAccessUserAutosuggest extends React.Component {
  static propTypes = {
    /* HOC/middleware props */
    classes: PropTypes.object.isRequired,
    /* passed props */
    onSelect: PropTypes.func.isRequired,
    doorAccesses: PropTypes.array.isRequired,
  }

  static styles = (theme) => ({
    input: {
      display: 'flex',
      padding: 0,
    },
    valueContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      flex: 1,
      alignItems: 'center',
      overflow: 'hidden',
    },
    noOptionsMessage: {
      padding: theme.spacing(1, 2),
    },
    optionFocus: {
      backgroundColor: theme.palette.action.hover,
    },
    singleValue: {
    },
    placeholder: {
      position: 'absolute',
      left: 2,
    },
    paper: {
      minWidth: '100%',
      width: 'fit-content',
      position: 'absolute',
      left: 0,
      right: 0,
    },
    createNew: {
      display: 'flex',
      alignItems: 'center',
      '& svg': {
        marginRight: 5,
      },
    },
  })

  createNewLabel = (value) => (
    <div className={this.props.classes.createNew}>
      <SvgIcon><path d={mdiAccountPlus} /></SvgIcon>
      <p>Create New User: <strong>{value}</strong></p>
    </div>
  )

  createNewData = (value, label) => (
    {
      id: value,
      name: label,
      isCreateNew: true,
    }
  )

  isValidNewOption = (inputValue, _, selectOptions) => (
    inputValue.trim().length > 0
    && !selectOptions.find((option) => option.name.toLowerCase() === inputValue.toLowerCase())
  )

  render() {
    const { classes, onSelect, doorAccesses } = this.props

    return (
      <CreatableSelect
        classes={classes}
        options={doorAccesses}
        getOptionLabel={(user) => user.name}
        getOptionValue={(user) => user.id}
        isValidNewOption={this.isValidNewOption}
        getNewOptionData={this.createNewData}
        formatCreateLabel={this.createNewLabel}
        menuPortalTarget={document.body}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 1301 }) }}
        onChange={onSelect}
        placeholder="Type a name"
        isClearable
        components={{
          Control,
          Menu,
          Option,
          Placeholder,
          SingleValue,
          ValueContainer,
          NoOptionsMessage,
        }}
      />
    )
  }
}

export default withStyles(DoorAccessUserAutosuggest.styles)(DoorAccessUserAutosuggest)
